export const SERVICE_PROVIDERS_API_URL = '/ui/organization/service_providers';

export const serviceProvidersQueryKeys = {
  all: [SERVICE_PROVIDERS_API_URL],
};
